import EfVideo from '@elem/ui/ef-video';
import { useEffect, useState } from 'react';
import { useMediaDevice } from '../../hooks';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

const icon = (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.837 11.359L14.3498 9.76849C14.6719 9.42959 15.2062 9.41748 15.5435 9.74113C15.8804 10.0644 15.8929 10.6015 15.5707 10.94L12.2056 14.5549C11.7768 15.0154 11.1531 15.2401 10.5306 15.1577L5.21533 14.4541"
            stroke="#E6A83C"
            strokeWidth="1.06719"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.8373 11.3588L13.7127 10.439C14.0345 10.1005 14.0224 9.56385 13.6851 9.2402C13.3481 8.91654 12.8135 8.92905 12.4918 9.26756L11.0308 10.8061"
            stroke="#E6A83C"
            strokeWidth="1.06719"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.57926 12.5211H12.053C12.5192 12.5211 12.8973 12.1416 12.8973 11.6729C12.8973 11.2046 12.5192 10.8251 12.053 10.8251L9.57926 10.8184L8.53925 10.2809C7.79883 9.89865 6.92534 9.87715 6.16741 10.2227L5.21533 10.657"
            stroke="#E6A83C"
            strokeWidth="1.06719"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.82629 15.2882H3.74308C3.52831 15.2882 3.354 15.1135 3.354 14.8973V10.0663C3.354 9.85017 3.52831 9.67545 3.74308 9.67545H4.82629C5.04106 9.67545 5.21537 9.85017 5.21537 10.0663V14.8973C5.21537 15.1135 5.04106 15.2882 4.82629 15.2882Z"
            stroke="#E6A83C"
            strokeWidth="1.06719"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx="9.40176" cy="5.86639" r="3.20156" stroke="#E6A83C" strokeWidth="1.06719" />
        <path
            d="M9.20265 4.12756V3.87997H9.42463V4.12756C10.0223 4.17024 10.6412 4.39222 10.7223 5.05387H10.0308V5.04961C10.0094 4.84897 9.79601 4.65261 9.42463 4.60566V5.38257H9.4289C10.0906 5.45087 10.8248 5.55332 10.8248 6.2662C10.8248 6.98335 10.0863 7.20533 9.42463 7.21813V7.64501H9.20265V7.21813C8.46843 7.18398 7.82812 6.94066 7.81104 6.18509H8.50258C8.52819 6.57355 8.827 6.72296 9.20265 6.76564V5.88628C8.56661 5.80517 7.88788 5.70699 7.88788 5.02826C7.88788 4.40502 8.45135 4.14036 9.20265 4.12756ZM9.20265 4.60566C9.04471 4.60992 8.5538 4.64407 8.5538 4.99838C8.5538 5.23743 8.81847 5.31427 9.20265 5.36976V4.60566ZM9.42463 5.93324V6.76564C9.80882 6.75284 10.1332 6.63758 10.1332 6.34304C10.1332 6.07411 9.83016 5.98873 9.42463 5.93324Z"
            fill="#E6A83C"
        />
    </svg>
);

export default function TheComp() {
    const { t } = useLang('Oasis.CutCosts');
    const { isH5 } = useMediaDevice();
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca'].includes(locale ?? '');

    const videos: { [key: string]: any } = {
        eu: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744253400070/%E5%BC%80%E5%8F%91-%E7%9C%81%E9%92%B1-1-EU-%E6%AC%A7%E5%85%83.mp4',
            pcPoster: 'https://websiteoss.ecoflow.com/upload/image/1744343108023/%E5%BC%80%E5%8F%91-%E7%9C%81%E9%92%B1-1-EU-%E6%AC%A7%E5%85%83.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1744253399788/%E5%BC%80%E5%8F%91_phone_%E7%9C%81%E9%92%B1_1_EU-%E6%AC%A7%E5%85%83.mp4',
            h5Poster: 'https://websiteoss.ecoflow.com/upload/image/1744343107925/%E5%BC%80%E5%8F%91_phone_%E7%9C%81%E9%92%B1_1_EU-%E6%AC%A7%E5%85%83.jpg',
        },
        uk: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744253690564/%E5%BC%80%E5%8F%91-%E7%9C%81%E9%92%B1-1-UK-%E8%8B%B1%E9%95%91.mp4',
            pcPoster: 'https://websiteoss.ecoflow.com/upload/image/1744343141938/%E5%BC%80%E5%8F%91-%E7%9C%81%E9%92%B1-1-UK-%E8%8B%B1%E9%95%91.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1744253690310/%E5%BC%80%E5%8F%91_phone_%E7%9C%81%E9%92%B1_1_UK-%E8%8B%B1%E9%95%91.mp4',
            h5Poster: 'https://websiteoss.ecoflow.com/upload/image/1744343141738/%E5%BC%80%E5%8F%91_phone_%E7%9C%81%E9%92%B1_1_UK-%E8%8B%B1%E9%95%91.jpg',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744253591417/%E5%BC%80%E5%8F%91-%E7%9C%81%E9%92%B1-1-EU-%E6%AC%A7%E5%85%83.mp4',
            pcPoster: 'https://websiteoss.ecoflow.com/upload/image/1744343174581/%E5%BC%80%E5%8F%91-%E7%9C%81%E9%92%B1-1-EU-%E6%AC%A7%E5%85%83.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1744253591241/%E5%BC%80%E5%8F%91_phone_%E7%9C%81%E9%92%B1_1_EU-%E6%AC%A7%E5%85%83.mp4',
            h5Poster: 'https://websiteoss.ecoflow.com/upload/image/1744343174460/%E5%BC%80%E5%8F%91_phone_%E7%9C%81%E9%92%B1_1_EU-%E6%AC%A7%E5%85%83.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744253640799/%E5%BC%80%E5%8F%91-%E7%9C%81%E9%92%B1-1-EU-%E6%AC%A7%E5%85%83.mp4',
            pcPoster: 'https://websiteoss.ecoflow.com/upload/image/1744343200774/%E5%BC%80%E5%8F%91-%E7%9C%81%E9%92%B1-1-EU-%E6%AC%A7%E5%85%83.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1744253640577/%E5%BC%80%E5%8F%91_phone_%E7%9C%81%E9%92%B1_1_EU-%E6%AC%A7%E5%85%83.mp4',
            h5Poster: 'https://websiteoss.ecoflow.com/upload/image/1744343200600/%E5%BC%80%E5%8F%91_phone_%E7%9C%81%E9%92%B1_1_EU-%E6%AC%A7%E5%85%83.jpg',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744253400070/%E5%BC%80%E5%8F%91-%E7%9C%81%E9%92%B1-1-EU-%E6%AC%A7%E5%85%83.mp4',
            pcPoster: 'https://websiteoss.ecoflow.com/upload/image/1744343108023/%E5%BC%80%E5%8F%91-%E7%9C%81%E9%92%B1-1-EU-%E6%AC%A7%E5%85%83.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1744253399788/%E5%BC%80%E5%8F%91_phone_%E7%9C%81%E9%92%B1_1_EU-%E6%AC%A7%E5%85%83.mp4',
            h5Poster: 'https://websiteoss.ecoflow.com/upload/image/1744343107925/%E5%BC%80%E5%8F%91_phone_%E7%9C%81%E9%92%B1_1_EU-%E6%AC%A7%E5%85%83.jpg',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744253400070/%E5%BC%80%E5%8F%91-%E7%9C%81%E9%92%B1-1-EU-%E6%AC%A7%E5%85%83.mp4',
            pcPoster: 'https://websiteoss.ecoflow.com/upload/image/1744343108023/%E5%BC%80%E5%8F%91-%E7%9C%81%E9%92%B1-1-EU-%E6%AC%A7%E5%85%83.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1744253399788/%E5%BC%80%E5%8F%91_phone_%E7%9C%81%E9%92%B1_1_EU-%E6%AC%A7%E5%85%83.mp4',
            h5Poster: 'https://websiteoss.ecoflow.com/upload/image/1744343107925/%E5%BC%80%E5%8F%91_phone_%E7%9C%81%E9%92%B1_1_EU-%E6%AC%A7%E5%85%83.jpg',
        },
    };
    const naVideos = {
        pc: 'https://websiteoss.ecoflow.com/upload/video/1742457994870/CutCosts.mp4',
        pcPoster: 'https://websiteoss.ecoflow.com/upload/image/1735636705750/CutCosts-poster.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/video/1742457970027/CutCosts-M.mp4',
        h5Poster: 'https://websiteoss.ecoflow.com/upload/image/1735637623634/CutCosts-poster-h5.jpg',
    };

    let video: HTMLVideoElement;
    useEffect(() => {
        const info = document.querySelector('#CutCosts .info') as HTMLDivElement;
        const callback = () => {
            // 保证视频跳到最后一帧并暂停
            video.currentTime = video.duration; // 跳转到最后一帧
            video.pause(); // 停止播放
        };
        // 是否完全可见
        const show = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        video = document.querySelector('#CutCosts video') as HTMLVideoElement;
                        info.classList.add('enter');
                        if (!video) return;
                        video.addEventListener('ended', callback);
                        video.currentTime = 0;
                        video.play();
                    } else {
                        info.classList.remove('enter');
                    }
                });
            },
            {
                threshold: 0.5,
            },
        );
        show.observe(document.getElementById('CutCosts') as HTMLDivElement);

        () => {
            show.disconnect();
            video?.removeEventListener?.('ended', callback);
        };
    }, []);

    const [videoLoaded, setVideoLoaded] = useState(false);
    useEffect(() => {
        const loader = AniContainer.create({
            triggerElement: IS_NA_SITES ? '#SmartBackup2' : '#SmartInsights',
            triggerHook: 1,
            offset: 0,
            duration: '100%',
            onEnter: () => {
                setVideoLoaded(true);
            },
        });
        return () => {
            loader.destroy();
        };
    }, []);
    return (
        <div className={`${styles.TheComp}`} id="CutCosts">
            {videoLoaded &&
                (!isH5 ? (
                    <EfVideo
                        pc={IS_NA_SITES ? naVideos.pc : videos[locale].pc}
                        poster={IS_NA_SITES ? naVideos.pcPoster : videos[locale].pcPoster}
                        key="CutCosts-pc"
                        preload="none"
                    />
                ) : (
                    <EfVideo
                        pc={IS_NA_SITES ? naVideos.h5 : videos[locale].h5}
                        poster={IS_NA_SITES ? naVideos.h5Poster : videos[locale].h5Poster}
                        key="CutCosts-pad"
                        preload="none"
                    />
                ))}
            <div className="info" key="CutCosts-info">
                {/* <div className="label">
                    {icon}
                    <span>{t('label')}</span>
                </div> */}
                <div className="title">{t('title')}</div>
                <div className="desc">{t.rich('desc', { h: (v: string) => <span className="highlight">{v}</span> })}</div>
            </div>
            <div className="cut-costs-desc">
                <div className="text-1">{t('text1')}</div>
                <div className="text-2">{t('text2')}</div>
            </div>
        </div>
    );
}
